import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate, useParams } from "react-router-dom";
import exportValue from "../../apiconfig";
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const Edit_email_template = () => {
    const { email_template } = useParams();
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
    
    let flagCheck = true;
    const [state, setState] = useState({ mail_format: "", title: "" });
    const [editorLoaded, setEditorLoaded] = useState(false);
    const [extraStates, setExtraStates] = useState({ isLoading: false });

    useEffect(() => {
        if (flagCheck) {
            flagCheck = false;
            getTemplateDetail();
        }
        setEditorLoaded(true);
    }, []);

    const getTemplateDetail = () => {
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/detail_email`;
        let sendData = { mail_id: email_template };

        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
            console.log("res ", res);
            if (res.data.output.length == 1) {
                setState(res.data.output[0]);
            }
        }).catch((e) => {
            console.error("Error fetching template:", e);
        });
    }

    const handleChange = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    }

    const handleEditorChange = (event, editor) => {
        const data = editor.getData();
        setState(prevState => ({
            ...prevState,
            mail_format: data
        }));
    };

    const handleEditorReady = (editor) => {
        console.log('Editor is ready to use!', editor);
    };

    const templateUpdate = () => {
        setExtraStates({ ...extraStates, isLoading: true });
        
        let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/update_email`;
        let sendData = state;

        axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
            console.log("res ", res);
            Swal.fire({
                icon: 'success',
                title: 'Success...',
                text: "Updated successfully",
            });
            setExtraStates({ ...extraStates, isLoading: false });
        }).catch((e) => {
            console.error("Error updating template:", e);
            setExtraStates({ ...extraStates, isLoading: false });
            Swal.fire({
                icon: 'error',
                title: 'Error...',
                text: "Failed to update template",
            });
        });
    }

    const editorConfiguration = {
        toolbar: {
            items: [
                'heading', '|',
                'fontfamily', 'fontsize', '|',
                'alignment', '|',
                'fontColor', 'fontBackgroundColor', '|',
                'bold', 'italic', 'strikethrough', 'underline', 'subscript', 'superscript', '|',
                'link', '|',
                'outdent', 'indent', '|',
                'bulletedList', 'numberedList', 'todoList', '|',
                'codeBlock', '|',
                'insertTable', '|',
                'imageUpload', 'blockQuote', '|',
                'undo', 'redo'
            ],
            shouldNotGroupWhenFull: true
        },
        image: {
            toolbar: [
                'imageStyle:inline',
                'imageStyle:block',
                'imageStyle:side',
                '|',
                'toggleImageCaption',
                'imageTextAlternative'
            ]
        },
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells'
            ]
        },
        fontFamily: {
            options: [
                'default',
                'Arial, Helvetica, sans-serif',
                'Courier New, Courier, monospace',
                'Georgia, serif',
                'Lucida Sans Unicode, Lucida Grande, sans-serif',
                'Tahoma, Geneva, sans-serif',
                'Times New Roman, Times, serif',
                'Trebuchet MS, Helvetica, sans-serif',
                'Verdana, Geneva, sans-serif'
            ]
        },
        fontSize: {
            options: [
                9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
                32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62, 64, 66, 68, 70, 72
            ]
        },
        link: {
            decorators: {
                addTargetToExternalLinks: {
                    mode: "automatic",
                    callback: (url) => /^(https?:)?\/\//.test(url),
                    attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                    },
                },
            },
        },
        simpleUpload: {
            uploadUrl: 'your-upload-endpoint', // Optional: if you have image upload
        },
        minHeight: 500,
        placeholder: 'Start typing your email template here...'
    };

    return (
        <div>
            <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            <section className="home-section">
                <Sub_header />
                
                <section>
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                        <div className="d-block mb-4 mb-md-0">
                            <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                    <li className="breadcrumb-item">
                                        <a href="#">
                                            <svg className="icon icon-xxs" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                                            </svg>
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Email Templates</li>
                                </ol>
                            </nav>
                            <h2 className="h4">Email Template</h2>
                        </div>
                        <div className="btn-toolbar mb-2 mb-md-0"></div>
                    </div>
                </section>

                <section id="generalinfo">
                    <div className="row">
                        <div className="col-12 col-xl-8">
                            <div className="card card-body border-0 shadow mb-4">
                                <div className="row">
                                    <div className="col-sm-12 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="title">Title</label>
                                            <input 
                                                className="form-control" 
                                                id="title" 
                                                type="text" 
                                                placeholder="Your email title" 
                                                name="title" 
                                                value={state.title}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12 mb-3">
                                        <div className="form-group">
                                            <label htmlFor="email-template">Email Template</label>
                                            {editorLoaded && (
                                                <CKEditor
                                                    editor={ClassicEditor}
                                                    config={editorConfiguration}
                                                    data={state.mail_format || ''}
                                                    onReady={handleEditorReady}
                                                    onChange={handleEditorChange}
                                                    onBlur={(event, editor) => {
                                                        const data = editor.getData();
                                                        setState(prevState => ({
                                                            ...prevState,
                                                            mail_format: data
                                                        }));
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <button 
                                        className="btn btn-gray-800 mt-2 animate-up-2" 
                                        type="button" 
                                        onClick={templateUpdate}
                                        disabled={extraStates.isLoading}
                                    >
                                        {extraStates.isLoading ? 'Saving...' : 'Save'}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-xl-4">
                            <div className="card card-body border-0 shadow mb-4">
                                <div className="row">
                                    <h4>Shortcodes</h4>
                                    <hr />
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Shortcode</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {[
                                                '@OTP@', '@CUSTOMER_NAME@', '@APP_NAME@', '@TRANSACTION_ID@',
                                                '@ORDER_DATE_TIME@', '@ORDER_ID@', '@AMOUNT@', '@COMPANY_NAME@',
                                                '@PAYMENT_MODE@', '@TYPE@', '@AWB@', '@CARRIER_NAME@',
                                                '@SHIPMENT_ID@', '@STATUS@', '@REASON@'
                                            ].map((shortcode, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <span className="badge rounded-pill bg-info fs-7 p-2">
                                                            {shortcode}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </div>
    );
}

export default Edit_email_template;